import axios from "axios";
import { PROCESS_AUTOMATION_SERVICE_URL } from "../Common/Constant/API";
import { commonRequestHeaders } from "../Common/request/headers";
import { getTenants } from "../Utils/JWTTokenUtil";

const getHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    Authorization: `Bearer ${token}`,
    "vf-trace-transaction-id": crypto.randomUUID(),
    ...commonRequestHeaders(),
  };
};

export const fetchRepositories = async () => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(
      `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/git/repositories`,
      {
        headers: {
          ...getHeaders(),
          "Content-Type": "application/json",
        },
      }
    );
    const tenantName = localStorage.getItem("selectedTenant") || getTenants()[0] || "";
    return (response.data || []).map((repo) => ({ ...repo, tenantName }));
  } catch (error) {
    console.error("Error fetching repositories:", error);
    throw error;
  }
};

export const fetchOpenedReleaseHotfixes = async () => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.post(
      `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/git/repositories/search`,
      {
        branchPatterns: ["release/*", "hotfix/*"],
      },
      {
        headers: {
          ...getHeaders(),
          "Content-Type": "application/json"
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching opened release/hotfixes:", error);
    throw error;
  }
};
